import { Products, Wine, WineInfo } from '../Model/types';
export const fetchWines = async (): Promise<Wine[]> => {
  try {
    const response = await fetch('https://elabuelowinebacknodejs-production.up.railway.app/Wines');
    
    if (!response.ok) {
      throw new Error(`Error al obtener la informacion de los vinos: ${response.statusText}`);
    }

    const data = await response.json();

    // Mapeo manual de snake_case a camelCase
    const mappedData: Wine[] = data.map((item: any) => ({
      id: item.id,
      name: item.name,
      imageUrl: item.image_url,
      labelUrl: item.label_url,
      grape: item.grape,
      productId: item.product_id,
      isSoldOut: item.is_sold_out,
    }));

    return mappedData;

  } catch (error) {
    console.error('Error al obtener la informacion los vinos:', error);
    throw error;
  }
};

export const fetchProducts = async (): Promise<Products[]> => {
  try {
    const response = await fetch('https://elabuelowinebacknodejs-production.up.railway.app/Products');
    
    if (!response.ok) {
      throw new Error(`Error al obtener la informacion de los productos: ${response.statusText}`);
    }

    const data = await response.json();

    // Mapeo manual de snake_case a camelCase
    const mappedData: Products[] = data.map((item: any) => ({
      id: item.id,
      product: item.product,
      color: item.color,
    }));

    return mappedData;

  } catch (error) {
    console.error('Error al obtener la informacion los productos:', error);
    throw error;
  }
};

export const fetchWineById = async (id: number): Promise<WineInfo> => {
  try {
    const response = await fetch(`https://elabuelowinebacknodejs-production.up.railway.app/Wine/${id}`);

    if (!response.ok) {
      throw new Error(`Error al obtener el vino con id ${id}: ${response.statusText}`);
    }

    const data = await response.json();

    // Mapeo manual de snake_case a camelCase
    const mappedData: WineInfo = {
      id: data.id,
      name: data.name,
      imageUrl: data.image_url,
      labelUrl: data.label_url,
      isSoldOut: data.is_sold_out,
      purchaseUrl: data.purchase_url,
      country: data.country,
      description: data.description,
      year: data.year,
      category: data.category,
      product: data.product,
      productId: data.product_id,
      netQuantity: data.net_quantity,
      unitOfMeasurement: data.unit_of_measurement,
      alcoholContent: data.alcohol_content,
      grape: data.grape,
      ingredientsText: data.ingredients_text,
      ingredientsObs: data.ingredients_obs,
      portions1: data.portions_1,
      milliliters1: data.milliliters_1,
      portions2: data.portions_2,
      milliliters2: data.milliliters_2,
      text1: data.text_1,
      text2: data.text_2,
      energy1: data.energy_1,
      fat1: data.fat_1,
      ofWhichSaturates1: data.of_which_saturates_1,
      carbohydrate1: data.carbohydrate_1,
      ofWhichSugars1: data.of_which_sugars_1,
      protein1: data.protein_1,
      salt1: data.salt_1,
      energy2: data.energy_2,
      fat2: data.fat_2,
      ofWhichSaturates2: data.of_which_saturates_2,
      carbohydrate2: data.carbohydrate_2,
      ofWhichSugars2: data.of_which_sugars_2,
      protein2: data.protein_2,
      salt2: data.salt_2
    };

    return mappedData;

  } catch (error) {
    console.error(`Error al obtener el vino con id ${id}:`, error);
    throw error;
  }
};
